window.app = window.app || {};

window.app.videoCarousel = {
  el: {
    navigation: document.querySelector('.mt-videos-carousel__nav'),
    navigationItems: document.querySelectorAll('.mt-videos-carousel__nav-link'),
    carousel: document.querySelector('.mt-videos-carousel__carousel .swiper'),
    videos: document.querySelectorAll('.mt-videos-carousel .yt-player')
  },

  init: function() {
    const _this = this;
    if (!_this.el.carousel) return;

    _this.slider = new Swiper(_this.el.carousel, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        1200: {
          spaceBetween: -36
        }
      }
    });

    if (_this.el.navigation && _this.el.navigationItems.length > 0) {
      _this.el.navigationItems.forEach(item => {
        item.addEventListener('click', e => { 
          e.preventDefault();
          const slide = _this.el.carousel.querySelector(`.mt-videos-carousel__item[data-slide-id='${item.dataset.slide}']`).closest('.swiper-slide');
          slide && _this.slider.slideTo(Array.from(slide.parentNode.children).indexOf(slide));
          (window.innerWidth < 768) && item.closest('li').scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        })
      });
      _this.slider.on('slideChangeTransitionStart', () => {
        const slide = _this.el.carousel.querySelector('.swiper-slide-active .mt-videos-carousel__item');
        _this.el.navigationItems.forEach(item => {
            if (item.dataset.slide == slide.dataset.slideId) {
                item.classList.add('active');
                (window.innerWidth < 768) && item.closest('li').scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            } else {
                item.classList.remove('active');
            }
        });
        _this.el.carousel.querySelectorAll('.mt-videos-carousel__item').forEach(s => {
            const video = s.querySelector('video');
            if (!video) return;
            (s === slide) ? video.play() : video.pause();
        });
      });
    }

    document.addEventListener('yt-api-loaded', () => {
      _this.el.videos.forEach(video => {
        let videoIsPlaying = false;
        const player = new YT.Player(video, {
          height: '360',
          width: '640',
          host: 'https://www.youtube-nocookie.com',
          videoId: video.dataset.id,
          playerVars: { 
            'autoplay': 0, 
            'rel': 0,
            'origin': window.location.host
          },
          events: {
            'onStateChange': (e) => {
              if (e.data === 1 && !videoIsPlaying) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                  event: 'video_play',
                  video_name: player.videoTitle
                });
                videoIsPlaying = true;
              }
            }
          }
        });

        _this.slider.on('slideChangeTransitionStart', (swiper) => {
          player.stopVideo();
        });
      });
    });

    // URL support
    const hash = window.location.hash.slice(1);
    if (hash) {
      const slide = document.querySelector(`.mt-videos-carousel__item[data-slide-id="${hash}"]`)?.closest('.swiper-slide:not(.swiper-slide-active)');
      if (slide?.dataset?.swiperSlideIndex) {
        _this.slider.slideTo(+slide.dataset.swiperSlideIndex);
      }
    }
  }
}

window.app.videoCarousel.init();